export interface ArchiveLinkAttributes {
  target?: "_blank";
  rel?: "noopener noreferrer";
}

/** カタログ設定に従って過去ログのリンク表示先を決定する。 */
export function getArchiveLinkAttributes(
  openInNewTab: boolean,
): ArchiveLinkAttributes {
  return openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {};
}
